import PropTypes from 'prop-types';
import Input from '../ui/Input';

// "Título oferta" se envía como `oferta`: la API busca en el título (nombre_oferta)
// o en el código (codigo_oferta) de la oferta.
const CAMPOS = [
  { id: 'nombre', label: 'Nombre', placeholder: 'Nombre' },
  { id: 'apellido', label: 'Apellidos', placeholder: 'Apellidos' },
  { id: 'oferta', label: 'Título oferta', placeholder: 'Título o código de la oferta' },
];

const FiltrosNotasD2l = ({ valores, onCambiar, disabled = false }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '12px',
    }}
  >
    {CAMPOS.map((campo) => (
      <Input
        key={campo.id}
        label={campo.label}
        type="text"
        name={campo.id}
        id={`notas-d2l-${campo.id}`}
        placeholder={campo.placeholder}
        maxLength={100}
        autoComplete="off"
        value={valores[campo.id]}
        onChange={(e) => onCambiar(campo.id, e.target.value)}
        disabled={disabled}
      />
    ))}
  </div>
);

FiltrosNotasD2l.propTypes = {
  valores: PropTypes.shape({
    nombre: PropTypes.string.isRequired,
    apellido: PropTypes.string.isRequired,
    oferta: PropTypes.string.isRequired,
  }).isRequired,
  onCambiar: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default FiltrosNotasD2l;
